import { DESKTOP_SPACING, FONT_SIZE, NATURAL } from "@/theme";

import styled from "styled-components";

export const StyledEmpty = styled.div`
  color: ${NATURAL.I};
  display: flex;
  flex-direction: column;
  font-size: ${FONT_SIZE.SM};
  gap: ${DESKTOP_SPACING.XXL}px;
  margin-bottom: ${DESKTOP_SPACING.XXXL}px;
  text-align: center;
`;